import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getCustomerServiceList as _getCustomerServiceList, addCustomerService, editCustomerService, getCustomerService, deleteCustomerService } from '@/services/systemsetting';
export default {
  name: 'customerService',
  components: {},
  i18n: require('./../i18n-basucSettings'),
  computed: {
    uploadLimit: function uploadLimit() {
      return localStorage.uploadLimit;
    }
  },
  data: function data() {
    return {
      id: '',
      loading: false,
      errTip: this.$t('public.enterPlease'),
      imageHost: "",
      customerServiceList: [],
      //联系客服列表数据
      isTableLoading: false,
      dialogStatus: '',
      //新建/修改状态位
      defaultLangObj: {},
      //默认语言对象
      languageList: [],
      //多语言list
      visible: false,
      //新建/修改 显示
      textMap: {
        update: this.$t('publicuse.edit'),
        create: this.$t('publicuse.new')
      },
      loadingIcon: false,
      typeList: [{
        value: 0,
        text: this.$t('basicSettings.phone')
      }, {
        value: 1,
        text: this.$t('basicSettings.WeChat')
      }, {
        value: 2,
        text: this.$t('basicSettings.other')
      }],
      initTypeList: [],
      datavalue: {
        titleDescriptionList: [],
        serviceType: undefined,
        serviceContent: "",
        serviceUrl: "",
        serviceIcon: ''
      },
      saveLoading: false,
      action: "",
      updateData: {},
      rules: {
        serviceType: [{
          required: true,
          message: this.$t('public.pleaseSelect'),
          trigger: 'change'
        }],
        serviceContent: [{
          required: true,
          message: this.$t('public.enterPlease'),
          trigger: 'blur'
        }],
        serviceUrl: [{
          required: true,
          message: this.$t('public.enterPlease'),
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.updateData = {
      type: 6
    };
    self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
    self.languageList = JSON.parse(localStorage.getItem('langList'));
    self.action = process.env.VUE_APP_API_BASE_URL + "/common/upload/";
    self.getInitialValue();
    self.getCustomerServiceList();
  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('public.pictureType'));
      }
      var isLt2M = file.size / 1024 / 1024 < this.uploadLimit;
      if (!isLt2M) {
        this.$message.error(this.$t('public.pictureMax', {
          uploadLimit: this.uploadLimit
        }));
      }
      return isJpgOrPng && isLt2M;
    },
    handleChangeIcon: function handleChangeIcon(info) {
      if (info.file.status === 'uploading') {
        this.loadingIcon = true;
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.code == 200) {
          this.datavalue.serviceIcon = info.file.response.data.uploadfilepath;
          this.loadingIcon = false;
        }
      }
    },
    //获取localStorage里面的默认语言和系统设置中存的语言list
    getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //类型
          nameObj.titleLable = self.$t('basicSettings.title') + '(' + item.langName + ')';
          nameObj.descriptionLable = self.$t('basicSettings.description') + '(' + item.langName + ')';
          nameObj.serviceTitle = "";
          nameObj.serviceDescription = "";

          //多语言id
          nameObj.langId = item.langId;
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          self.initTypeList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.datavalue.titleDescriptionList = _.cloneDeep(self.initTypeList);
    },
    //获取列表
    getCustomerServiceList: function getCustomerServiceList() {
      var self = this;
      self.isTableLoading = true;
      _getCustomerServiceList().then(function (res) {
        if (res.data.code == 200) {
          self.imageHost = res.data.data.imageHost;
          self.customerServiceList = res.data.data.list;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    /* 初始化输入项 */resetdatavalue: function resetdatavalue() {
      var self = this;
      self.datavalue = {
        titleDescriptionList: _.cloneDeep(self.initTypeList),
        serviceType: undefined,
        serviceContent: "",
        serviceUrl: "",
        serviceIcon: ''
      };
      if (self.id) {
        self.datavalue.id = self.id;
      }
    },
    /* 删除按钮 */onDelete: function onDelete(id) {
      var _this = this;
      deleteCustomerService(id).then(function (result) {
        if (result.data.code == 200) {
          _this.$message.success(_this.$t('public.deleteSuccessfully'));
          _this.getCustomerServiceList();
        } else {
          //					this.$message.error(result.data.message);
          return false;
        }
      });
    },
    /* 编辑按钮 */edit: function edit(record) {
      var self = this;
      self.resetdatavalue();

      //获取详情数据
      getCustomerService(record.serviceId).then(function (res) {
        //				console.log(res.data)
        if (res.data.code == 200) {
          var rs = res.data.data;
          self.id = rs.id;
          self.datavalue = {
            id: rs.id,
            titleDescriptionList: _.cloneDeep(self.initTypeList),
            serviceType: rs.serviceType,
            serviceContent: rs.serviceContent,
            serviceUrl: rs.serviceUrl,
            serviceIcon: rs.serviceIcon
          };
          //给多语言集合赋值
          rs.titleDescriptionList.forEach(function (item, index) {
            self.datavalue.titleDescriptionList.forEach(function (itemModal, index) {
              if (item.langId == itemModal.langId) {
                itemModal.id = item.id;
                itemModal.langId = item.langId;
                itemModal.serviceTitle = item.serviceTitle;
                itemModal.serviceDescription = item.serviceDescription;
              }
            });
          });
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
      self.dialogStatus = 'update';
      this.loadingIcon = false;
      self.visible = true;
      this.saveLoading = false;
    },
    /* 添加按钮 */add: function add() {
      var _this2 = this;
      this.dialogStatus = 'create';
      this.resetdatavalue();
      this.$nextTick(function () {
        _this2.loadingIcon = false;
        _this2.visible = true;
      });
      this.saveLoading = false;
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.resetdatavalue();
      this.visible = false;
    },
    typeChange: function typeChange(serviceType) {
      var self = this;
      self.resetdatavalue();
      self.datavalue.serviceType = serviceType;
    },
    /* 确定添加 */save: function save() {
      var _this3 = this;
      var self = this;
      console.log(self.datavalue);
      this.saveLoading = true;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          //调接口
          var newData = self.datavalue;
          addCustomerService(newData).then(function (result) {
            if (result.data.code == 200) {
              self.getCustomerServiceList();
              self.$message.success(self.$t('public.saveSuccessfully'));
              _this3.saveLoading = false;
              self.visible = false;
            } else {
              _this3.saveLoading = false;
              //								self.$message.error(result.data.message);
              //								return false;
            }
          }).finally(function () {
            _this3.saveLoading = false;
          });
        } else {
          console.log('error submit!!');
          _this3.saveLoading = false;
          return false;
        }
      });
    },
    //弹框更新
    update: function update() {
      var _this4 = this;
      var self = this;
      this.saveLoading = true;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          //调接口
          var newData = self.datavalue;
          editCustomerService(newData).then(function (result) {
            if (result.data.code == 200) {
              _this4.getCustomerServiceList();
              _this4.$message.success(_this4.$t('public.saveSuccessfully'));
              _this4.saveLoading = false;
              self.visible = false;
            } else {
              _this4.saveLoading = false;
              //							this.$message.error(result.data.message);
              //							return false;
            }
          }).finally(function () {
            _this4.saveLoading = false;
          });
        } else {
          console.log('error submit!!');
          _this4.saveLoading = false;
          return false;
        }
      });
    }
  }
};